import {FC} from 'react';
import {Route, Routes} from 'react-router-dom';
import {withRouter} from '~/providers/with-router.tsx';
import TnTabbedNavbar from '@touchnet/react-tabbed-navbar';

import AccountingCodesListPage from './accounting-codes-list-page';
import CommonWorktagsPage from './common-worktags-page';
import {getActiveTab} from '~/utils/nav-utils';
import routes, {getRoute} from "~/route-map";
import {useSelector} from "react-redux";
import Selectors from "~/state/selectors.ts";

interface ComponentProps {
  location: any;
}

export const AccountingCodesPage: FC<ComponentProps> = ({location}) => {

    const cnum = useSelector(Selectors.getCustomerNumber);
    const ctx = useSelector(Selectors.getAppContext);
    const mainUrl = getRoute(routes.app.base,{cnum, ctx});

    const activeTab = getActiveTab(location.pathname, /\/ac\/([-a-z]+)/iu, 'codes');

    const pageTabs = [
        {
            id: 'codes',
            href: `${mainUrl}/ac/codes`,
            label: 'Accounting Codes',
        },
        {
            id: 'worktags',
            href: `${mainUrl}/ac/worktags`,
            label: 'Common Worktags',
        },
    ];

    return (
        <div>
            <h2 className="mb-3">Accounting Codes</h2>
            <TnTabbedNavbar activeTab={activeTab} tabs={pageTabs} />

            <div className="pt-3">
                <Routes>
                    <Route path={`/codes`} element={<AccountingCodesListPage />} />
                    <Route path={`/worktags`} element={<CommonWorktagsPage />} />
                </Routes>
            </div>
        </div>
    );
};

export default withRouter(AccountingCodesPage);
